import { fromJS } from 'immutable'

import { setLoginStorage, flushStorage, setMe, setPermissions, setSession } from 'utils/storage'
import { catchErr } from 'utils/helpers'

let initialState = fromJS({
  userID: 0,
  me: {},
  permissions: [],
  session: {},
  error: '',
  pending: false,
  sem_changed: false, // if this changes to true, hard refresh
  logout: false,
})

export const loginState = fromJS({
  username: '',
  password: '',
})

const isLoggedIn = Number(localStorage.getItem('token:user_id'))
if (isLoggedIn) {
  initialState = initialState
    .set('userID', isLoggedIn)
    .set('me', fromJS(JSON.parse(localStorage.getItem('me'))))
    .set('permissions', fromJS(JSON.parse(localStorage.getItem('permissions'))))
    .set('session', fromJS(JSON.parse(localStorage.getItem('session'))))
}

export default function auth(state = initialState, action) {
  // catch the _FAIL action types
  // if status becomes 401 - which means jwt token has expired
  const failed = /.*_FAIL$/

  if (action.type.match(failed)) {
    if (action.payload.status === 401) {
      try {
        flushStorage()
      } catch (e) {
        catchErr(e)
      }
      return state
        .set('pending', false)
        .set('error', action.payload.response.error)
        .set('userID', 0)
    }
  }

  switch (action.type) {
    // on the process of logging in
    case 'AUTH_REQ':
    case 'USERS_REQ':
    case '_REQ':
      // check if preflight request has error
      if (action.error) {
        return state
          .set('pending', false)
          .set('error', action.payload.message)
      }
      return state
        .set('pending', true)
        .set('error', '')

    // upon successful login
    case 'AUTH_SUCC':
    case 'AUTH_REFRESH':
      try {
        setLoginStorage(action.payload)
      } catch (e) {
        catchErr(e)
      }
      return state
        .set('pending', false)
        .set('userID', action.payload.user_id)

    // upon login fail
    case 'AUTH_FAIL':
    case 'USERS_ME_FAIL':
      return state
        .set('pending', false)
        .set('error', action.payload.response.error)

    // upon logout
    case 'AUTH_OUT':
      try {
        flushStorage()
      } catch (e) {
        catchErr(e)
      }
      return state.set('logout', true)

    // /users/me
    case 'USERS_ME_SUCC':
      try {
        setMe(action.payload.me)
        setPermissions(action.payload.permissions)
        setSession(action.payload.session)
      } catch (e) {
        catchErr(e)
      }
      return state
        .set('pending', false)
        .set('me', fromJS(action.payload.me))
        .set('permissions', fromJS(action.payload.permissions))
        .set('session', fromJS(action.payload.session))

    // sem changed
    case 'SESSION_CHANGE_SUCC':
      try {
        setSession(action.payload)
      } catch (e) {
        catchErr(e)
      }
      return state
        .set('pending', false)
        .set('session', fromJS(action.payload))
        .set('sem_changed', true)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/containers/Auth/reducer.js